import service from './../utils/server'
const modName = '/common/web/select/';
/**
 * 用户类型
 * @param data
 */
export const userType = data => {
    return service({
        url: modName + 'userType',
        method: 'post',
        data
    })
};

/**
 * 角色
 */
export const selectRole = data => {
  return service({
    url: modName + 'roleInfo',
    method: 'post',
    data
  })
};

//任务类型
export const taskPkgTypeSelect = data => {
  return service({
    url: modName + 'taskPkgTypeSelect',
    method: 'post'
  });
};

//任务状态
export const taskPkgStatusSelect = data => {
  return service({
    url: modName + 'taskPkgStatusSelect',
    method: 'post'
  });
};

//区域城市下拉框
export const taskPkgAreaCitySelect = data => {
  return service({
    url: modName + 'taskPkgAreaCitySelect',
    method: 'post',
    data: data
  });
};

//经销商
export const customerSelect = data => {
  return service({
    url: modName + 'customerSelect',
    method: 'post',
    data: data
  });
};

/**
 * 图片上传
 * @param data
 */
export const uploadImage = data =>{
  let config = {
    headers: {
      "Accept": '*/*',
      'Content-Type': 'multipart/form-data'
    }
  };
  return service({
    ...config,
    url: 'common/web/upload/img',
    method: 'post',
    data
  });
}

/**
 * 大区
 * @param data
 */
export const taskPkgAreaSelect = data => {
  return service({
    url: modName + 'taskPkgAreaSelect',
    method: 'post',
    data: data
  });
};

/**
 * 大区列表下拉框
 * @param data
 */
export const regionSelect = data => {
  return service({
    url: modName + 'regionSelect',
    method: 'post',
    data: data
  });
};











// WEBPACK FOOTER //
// ./src/api/selects.js